<template>
  <el-dialog :visible.sync="loginDialog" width="425px">
    <h3 style="text-align: center">您需要登录才能解锁更多操作权限</h3>
    <div
      v-loading="loginLoading"
    >
      <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="账号密码登录" name="password">
          <div
            v-loading="loginLoading"
            :element-loading-text="$t(loginStatus)"
          >
            <div
              v-if="loginStatus === 'Logining....'">
              <el-form label-position="top" label-width="120px" :model="loginForm" :rules="loginRules">
                <el-form-item :label="'Steam '+$t('Account')" prop="accountName">
                  <el-input v-model="loginForm.accountName" spellcheck="false"></el-input>
                </el-form-item>
                <el-form-item :label="'Steam '+$t('Password')" prop="password">
                  <el-input v-model="loginForm.password" spellcheck="false" show-password
                            @keydown.native="handleKeyDown"></el-input>
                </el-form-item>
              </el-form>
              <div style="text-align: center">
                <el-button type="primary" @click="loginByPassword">{{ $t('loginButton1') }}</el-button>
              </div>
            </div>
            <div v-if="loginStatus === 'Logining'">
              <el-form :model="confirmForm" :rules="confirmFormRules" label-position="top" label-width="120px">
                <el-form-item label="Steam GuardCode" prop="guardCode">
                  <el-input v-model="confirmForm.guardCode"></el-input>
                </el-form-item>
              </el-form>
              <div style="text-align: center">
                <el-button type="primary" @click="handleLoginByConfirm">{{ $t('Confirm') }}</el-button>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="扫码登录" name="qrCode">
          <div style="text-align: center">
            <canvas ref="qrCanvas"></canvas>
          </div>
          <div class="_3pxTSyPhDmjNqXUYDIITS-" style="text-align: center;font-size: 12px;color: #afafaf;">
            通过二维码使用
            <a class="_1K431RbY14lkaFW6-XgSsC _2FyQDUS2uHbW1fzoFK2jLx" href="https://store.steampowered.com/mobile">
              Steam 手机应用</a>登录
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </el-dialog>
</template>

<script>
import {
  loginByConfirm, loginByPassword,
  loginSteamCommunity,
  requestSteamQRCode
} from "../../api/api";
import i18n from "../../main";
import {getRefreshToken} from "../../api/util";
import QRCode from 'qrcode';

export default {
  name: "loginDialog",
  data() {
    return {
      activeName:'password',
      loginDialog: false,
      loginForm: {
        accountName: '',
        password: ''
      },
      confirmForm: {
        weakToken: '',
        guardCode: ''
      },
      loginLoading: false,
      loginStatus: 'Logining....',
      loginRules: {
        accountName: [
          {required: true, trigger: 'blur'},
        ],
        password: [
          {required: true, trigger: 'blur'}
        ],
      },
      confirmFormRules: {
        guardCode: [
          {required: true, trigger: 'blur'}
        ],
      },
      qrCodeDataUrl:''
    }
  },
  methods: {
    handleKeyDown(e){
      if (e.keyCode == 13){
        this.loginByPassword()
      }
    },
    handleLoginByConfirm(){
      let vm = this
      loginByConfirm({weakToken:this.confirmForm.weakToken,guardCode:this.confirmForm.guardCode}).then(json=>{
        localStorage.setItem("cookies", json.data.cookies)
        localStorage.setItem("steamId",json.data.steamId)

        vm.$store.commit('setLogin', true)
        vm.loginDialog = false

        vm.$emit('loginSuccess')
      }).catch(e=>{

      })
    },
    handleClick(){
      this.$nextTick(_=>{
        switch (this.activeName){
          case "password":
            this.loginForm = {
              accountName: '',
              password: ''
            }
            break
          case "qrCode":
            this.requestSteamQRCode()
            break
        }
      })
    },
    requestSteamQRCode(){
      let vm = this
      let qrChallengeUrl;
      requestSteamQRCode().then(json=>{
        if (json.status == 200){
          qrChallengeUrl = json.data
          const canvas = this.$refs.qrCanvas;
          const ctx = canvas.getContext('2d');
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          QRCode.toCanvas(canvas, qrChallengeUrl, { width: 200 }, (error) => {
            if (error) console.error(error);
            console.log('二维码生成成功！');
          });
        }else{
          this.$message.error('获取登陆码失败');
        }
      }).then(_=>{
        // 立即请求尝试登陆
        loginByConfirm({qrChallengeUrl:qrChallengeUrl}).then(json=>{
          localStorage.setItem("cookies", json.data.cookies)
          localStorage.setItem("steamId",json.data.steamId)

          vm.$store.commit('setLogin', true)
          vm.loginDialog = false

          vm.$emit('loginSuccess')
        }).catch(e=>{
          this.requestSteamQRCode()
        })
      })
    },
    loginByPassword() {
      this.loginLoading = true
      loginByPassword({
        accountName: this.loginForm.accountName,
        password: this.loginForm.password
      }).then(json => {
        // 等待令牌确认
        this.confirmForm.weakToken = json.data.data
        this.loginStatus = 'Logining'
      }).catch(e => {
        this.$message.error(e.message);
      }).finally(_ => {
        this.loginLoading = false
      })
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/ui/Login/index.vue